import { useState } from 'react';
import { brand, brandCopyright } from '@/config/brand';
import { AuthShell } from './components/AuthShell';
import { WafPromoBanner, WAF_GUIDE_URL } from '@/components/promos/WafPromoBanner';
import { LoginForm } from './components/LoginForm';
import { EmailVerificationForm } from './components/EmailVerificationForm';
import { TotpVerificationForm } from './components/TotpVerificationForm';

type Step =
  | { kind: 'login' }
  | { kind: 'email'; email: string; uncompleted: boolean }
  | { kind: 'totp'; email: string; password: string };

export default function LoginPage() {
  const [step, setStep] = useState<Step>({ kind: 'login' });
  const backToLogin = () => setStep({ kind: 'login' });

  if (step.kind === 'totp') {
    return (
      <AuthShell
        title="Two-factor authentication"
        subtitle="Enter the code from your authenticator app."
      >
        <TotpVerificationForm
          email={step.email}
          password={step.password}
          onBack={backToLogin}
        />
      </AuthShell>
    );
  }

  if (step.kind === 'email') {
    return (
      <AuthShell title="Verify your email" subtitle="One more step to continue.">
        <EmailVerificationForm
          email={step.email}
          uncompleted={step.uncompleted}
          onBack={backToLogin}
        />
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Login"
      footer={brandCopyright()}
      splitPane={
        brand.promos.wafFree ? (
          <WafPromoBanner
            flush
            ctaLabel="See the 3-step setup"
            onActivate={() => window.open(WAF_GUIDE_URL, '_blank', 'noopener,noreferrer')}
          />
        ) : undefined
      }
    >
      <LoginForm
        onEmailMfa={(email, uncompleted) =>
          setStep({ kind: 'email', email, uncompleted })
        }
        onTotpMfa={(email, password) => setStep({ kind: 'totp', email, password })}
      />
    </AuthShell>
  );
}
